import { useTranslation } from 'next-i18next'

import { Link } from '~/components/Link'

import SVGImage from './Image/SVGImage'

export function LinkHoMLogo({ logoRoute }: { logoRoute: string }): React.ReactElement {
  const { t } = useTranslation(['imageAlt'])
  return (
    <Link className="p-3 md:py-4" to={logoRoute}>
      <SVGImage
        alt={t('imageAlt:icons.houseOfMath')}
        height={45}
        imageClassName="w-36 md:w-auto"
        srcKey="logos/house-of-math.svg"
        width={234}
      />
    </Link>
  )
}
